import React from 'react'
import {
	CellMeasurer,
	CellMeasurerCache,
	AutoSizer,
	List,
	ListRowProps,
} from 'react-virtualized'

const cache = new CellMeasurerCache({
	defaultWidth: 100,
	fixedWidth: true,
})

export type { ListRowProps }

interface PropsType {
	list: any[]
	item: (rowProps: ListRowProps) => JSX.Element
}

export const VirtualizedList = (props: PropsType) => {
	const { list, item } = props

	const rowRenderer = (rowProps: ListRowProps) => {
		const { key, index, parent } = rowProps
		return (
			<CellMeasurer
				cache={cache}
				columnIndex={0}
				key={key}
				parent={parent}
				rowIndex={index}
			>
				{item({ ...rowProps })}
			</CellMeasurer>
		)
	}

	return (
		<AutoSizer>
			{({ width, height }) => (
				<List
					height={height}
					width={width}
					overscanRowCount={10}
					rowCount={list.length}
					rowHeight={cache.rowHeight}
					rowRenderer={rowRenderer}
					deferredMeasurementCache={cache}
					list={list}
				/>
			)}
		</AutoSizer>
	)
}
